import client from './apiErpConnector';

async function getSheets(size = 4, start = 0) {
  return client().get('/v2/erp/sheets', { params: { start, size } });
}

async function getSheet(sheetId) {
  return client().get(`/sheets/${sheetId}`);
}

async function getOrphanSheets(destinationId, start = 0, size = 15, search = '') {
  return client().post(`/destinations/${destinationId}/sheets`, {
    start,
    size,
    filters: [
      ...(search.length ? [
        {
          field: 'raison_sociale',
          operand: 'ilike',
          value: search,
        },
      ] : []),
    ],
    onlyOrphans: true,
  });
}

export default {
  getSheets,
  getSheet,
  getOrphanSheets,
};
